import { Box, Grid2 } from "@mui/material";
import { useTranslation } from "react-i18next";
import ReactRotatingText from "react-rotating-text";
import "@lottiefiles/lottie-player";

export function FormConfirmingSpinner() {
  const { t } = useTranslation();

  const content = [
    t("Check if location is available for booking"),

    t("Check if floor is available for booking"),

    t("Occupied places are being determined"),

    t("Inactivated places are being determined")
  ];

  return (
    <Grid2 container direction={"column"} justifyContent={"center"} alignItems={"center"}>
      <Box data-testid={"lottie_player"} style={{ height: 300 }}>
        <lottie-player
          src="https://assets5.lottiefiles.com/datafiles/aba45c7b75d547282b2dbdc97969412b/progress_bar.json"
          autoplay
          mode="normal"
          style={{ width: "200px" }}
        />
      </Box>
      <div style={{ textAlign: "center", marginTop: -130 }}>
        <ReactRotatingText items={content} emptyPause={250} pause={1000} typingInterval={40} />
      </div>
    </Grid2>
  );
}
